// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"2e0fc50f","850":"21f92258"}[chunkId] + ".chunk.js";
};